










import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as types from "@/store/constants/setting_types";
import ExclusivePakage from "./ExclusivePakage.vue";
import BuyVipEntrance from "./BuyVipEntrance/BuyVipEntrance.vue";
import * as cgConst from "@/api/cg/base/cg_const";
@Component({
  components: { ExclusivePakage, BuyVipEntrance }
})
export default class VipEntrance extends Vue {
  @Prop({ default: false })
  private isVip: any;
  @Action(types.UPDATE_GX_SETTING_DATA)
  private updateSetting: any;

  private mounted() {
    this.updateSetting(cgConst.TAB_COIN_STORE_KEYS);
  }
}
